import { render, staticRenderFns } from "./landing-banner-cmp.vue?vue&type=template&id=2cd6e998&scoped=true"
import script from "./landing-banner-cmp.vue?vue&type=script&lang=js"
export * from "./landing-banner-cmp.vue?vue&type=script&lang=js"
import style0 from "./landing-banner-cmp.vue?vue&type=style&index=0&id=2cd6e998&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd6e998",
  null
  
)

export default component.exports